import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ROLE_HOME = {
  dipendente: "/oggi",
  responsabile: "/oggi",
  resp_logistica: "/logistica",
  rider: "/logistica",
  super_admin: "/admin/home",
  cliente: "/cliente",
};

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === undefined) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#FAFAFA]">
        <div className="text-[#1F1F1F] text-lg font-medium">Caricamento…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles) {
    // L'utente accede se il suo ruolo primario O uno dei ruoli extra è nella lista.
    const allUserRoles = [user.role, ...(user.extra_roles || [])];
    if (!allUserRoles.some((r) => roles.includes(r))) {
      return <Navigate to={ROLE_HOME[user.role] || "/oggi"} replace />;
    }
  }
  return children;
}

export function RoleRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={ROLE_HOME[user.role] || "/oggi"} replace />;
}
